import { useState } from "react";
import cn from "classnames";
import { ContainerData } from "features/shared/OpenedCardEvents/types";
import { DropDownAnimation } from "shared/ui/DropDownAnimation";
import { ArrowRightShortIcon } from "shared/ui/Icons";
import styles from "./ContainerList.module.scss";

import { Event } from "../Event";

export const Container: RFC<{ container: ContainerData }> = ({ container }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className={styles.container}>
      <div onClick={() => setOpen((prev) => !prev)} className={styles.toggler}>
        <span>{container.number}</span>
        <ArrowRightShortIcon className={cn(styles.arrow, isOpen && styles.opened)} />
      </div>

      <DropDownAnimation isOpen={isOpen} duration={500} className={styles.events}>
        {container.events.map((eventEntry, eventEntryIndex) => {
          const isLastEvent = container.events.length - 1 === eventEntryIndex;

          return (
            <Event
              key={`${eventEntry.location}${eventEntry.isFutureEvent}`}
              eventEntry={eventEntry}
              isLastEvent={isLastEvent}
            />
          );
        })}
      </DropDownAnimation>
    </div>
  );
};
